var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('picture',[_c('source',{attrs:{"srcset":require("./backgroundImage.jpeg")}}),_c('img',{attrs:{"src":require("./backgroundImage.jpeg")}})])
}]

export { render, staticRenderFns }